import { render, staticRenderFns } from "./clickplay_faq.vue?vue&type=template&id=2b6b726f&scoped=true&"
import script from "./clickplay_faq.vue?vue&type=script&lang=js&"
export * from "./clickplay_faq.vue?vue&type=script&lang=js&"
import style0 from "./clickplay_faq.vue?vue&type=style&index=0&id=2b6b726f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b726f",
  null
  
)

export default component.exports